import create from './create'
import edit from './edit'
import view from './view'

export default {
    create,
    edit,
    view,

    new: 'New',
    title: 'Innovation fields',
    pageTitle: 'INNOVATION FIELDS - OVERVIEW',
    empty: {
        title: 'Looking for innovations?',
        content: 'Create the first innovation field.',
        action: 'Create innovation field'
    },
    noPublicInnovationProjects: 'Note: The public view of your innovation projects is deactivated. Links to innovation projects are therefore not active in the public view.',
    privateTrendRadars: 'Your innovation fields contain non-published trend radar links. To display these links in the published innovation fields, please activate the Public View of these trend radars.<br/>The following innovation fields contain non-published trend radar links:'
}
